import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Flowbite } from 'flowbite-react';
import { ToastProvider } from './components/ToastProvider';
import App from './routes/App';
import './index.css';
import { BASENAME } from './config';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Flowbite>
    <ToastProvider>
      <BrowserRouter basename={BASENAME || undefined}>
        <App />
      </BrowserRouter>
    </ToastProvider>
  </Flowbite>
);